import React, { useState, useEffect } from "react";
import InputField from "../../components/InputComponent/InputField";
import ButtonWithIcon from "../../components/ButtonwithIcon/ButtonWithIcon";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import "./PersonalDetails.scss";

const CertificationHistory = () => {
  const [certifications, setCertifications] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [newCertification, setNewCertification] = useState({
    certificationId: 0,
    certificationName: "",
    description: "",
    certifiedOn: "",
    institutionName: "",
  });

  // Fetch certifications on component mount
  useEffect(() => {
    fetchCertifications();
  }, []);

  const fetchCertifications = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/certifications/All`,
      );
      if (response.status === 200) {
        setCertifications(response.data.data); // Make sure this points to the correct structure
      }
    } catch (error) {
      console.error("Error fetching certifications:", error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setNewCertification((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      // Check if certification already exists by name
      const existingCertification = certifications.find(
        (cert) => cert.certificationName === newCertification.certificationName,
      );

      if (existingCertification) {
        // If it exists, update it
        await axiosInstance.put(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/certifications`,
          {
            ...newCertification,
            certificationId: existingCertification.certificationId,
          },
        );
      } else {
        // If it does not exist, create it
        await axiosInstance.post(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/certifications`,
          newCertification,
        );
      }

      toast.success("Certification saved successfully!");
      setNewCertification({
        certificationId: 0,
        certificationName: "",
        description: "",
        certifiedOn: "",
        institutionName: "",
      });
      fetchCertifications(); // Refresh the certifications after saving
    } catch (error) {
      console.error("Error saving certification", error);
      toast.error("Failed to save certification!");
    }
  };

  const handleEditCertification = (cert) => {
    setNewCertification({
      certificationId: cert.certificationId,
      certificationName: cert.certificationName,
      description: cert.description,
      certifiedOn: cert.certifiedOn.split("T")[0], // fix date format
      institutionName: cert.institutionName,
    });
  };

  const handleDeleteCertification = async (certificationId) => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/certifications/${certificationId}`,
      );
      setCertifications(
        certifications.filter(
          (cert) => cert.certificationId !== certificationId,
        ),
      );
      toast.success("Certification deleted successfully!");
    } catch (error) {
      console.error("Error deleting certification", error);
      toast.error("Failed to delete certification!");
    }
  };

  return (
    <div className="profile-form">
      <form className="form-section" onSubmit={handleFormSubmit}>
        <h2>Certification History</h2>
        <p>Add or update your certifications below.</p>
        <InputField
          label="Certification Name"
          id="certificationName"
          value={newCertification.certificationName}
          onChange={handleInputChange}
          required
        />
        <InputField
          label="Description"
          id="description"
          xw
          value={newCertification.description}
          onChange={handleInputChange}
        />
        <InputField
          label="Certified On"
          id="certifiedOn"
          type="date"
          value={newCertification.certifiedOn}
          onChange={handleInputChange}
          required
        />
        <InputField
          label="Institution Name"
          id="institutionName"
          value={newCertification.institutionName}
          onChange={handleInputChange}
          required
        />
        <div>
          <ButtonWithIcon
            text="Save"
            icon="mdi:content-save"
            className="success"
            type="submit"
          />
        </div>
      </form>

      <div className="social-links-display">
        <h3>Current Certifications:</h3>
        {certifications.map((cert) => (
          <div key={cert.certificationId} className="certification-item">
            <p>
              <strong>{cert.certificationName}</strong> - {cert.institutionName}
              <br />
              {cert.description} <br />
              Certified On: {new Date(cert.certifiedOn).toLocaleDateString()}
            </p>
            {editMode && (
              <>
                <ButtonWithIcon
                  text="Edit"
                  icon="mdi:pencil"
                  className="edit-button"
                  onClick={() => handleEditCertification(cert)}
                />
                <ButtonWithIcon
                  text="Delete"
                  icon="mdi:delete"
                  className="cancel-button"
                  onClick={() =>
                    handleDeleteCertification(cert.certificationId)
                  }
                />
              </>
            )}
          </div>
        ))}
        <ButtonWithIcon
          text={editMode ? "Cancel Editing" : "Edit"}
          className="edit-button"
          icon={editMode ? "mdi:cancel" : "mdi:pencil"}
          onClick={() => setEditMode(!editMode)}
        />
      </div>
    </div>
  );
};

export default CertificationHistory;
